import Image from "next/image";
import { LangCode } from "../i18n/lang-context";

export function Flag({countryOrLangCode, width, height}: {countryOrLangCode: string|LangCode, width: number, height: number}) {
  countryOrLangCode = countryOrLangCode.toUpperCase()
  const flag = countryOrLangCode === 'EN' || countryOrLangCode === 'UK' ? 'GB' : countryOrLangCode

  return <Image alt={countryOrLangCode} src={'/icons/flags/'+flag+'.svg'} width={width} height={height} />
}